import { Mail } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';
import { CONTACT_EMAIL } from '../data/divisions';
import './CTASection.css';

export function CTASection() {
  const { t } = useI18n();

  return (
    <section className="section cta-section">
      <div className="cta-card reveal">
        <span className="cta-glow" aria-hidden="true" />
        <h2>{t('cta.title')}</h2>
        <p>{t('cta.lead')}</p>
        <a className="btn btn-primary" href={`mailto:${CONTACT_EMAIL}`}>
          <Mail size={18} />
          {t('cta.button')}
        </a>
      </div>
    </section>
  );
}
